import { render, staticRenderFns } from "./registration-form.html?vue&type=template&id=0e5bcbac&scoped=true&external"
import script from "./registration-form.js?vue&type=script&lang=js&external"
export * from "./registration-form.js?vue&type=script&lang=js&external"
import style0 from "./registration-form.scss?vue&type=style&index=0&id=0e5bcbac&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5bcbac",
  null
  
)

export default component.exports